(function (Drupal, $, once) {
  "use strict";

  // To understand behaviors, see https://www.drupal.org/node/2269515
  Drupal.behaviors.scripts = {
    attach: function (context, settings) {

    $(once("scripts", ".accordion"))
      .each(function () {
        //console.log('accordion is running');
        $(this).find('.paragraph--type--accordion-block').each(function() {
          $(this).find('.js-accordion__panel').attr('aria-expanded', 'true');
        });

      });

    $(once("scripts", ".general-listing__form .expander"))
      .each(function () {
        /**
         * filter mobile trigger
         */
        //console.log('general listing form is running');
        var $filterTrigger = $(".general-listing__form .expander");
        var $filters = $(
          ".general-listing__form form.views-exposed-form"
        );
        $filterTrigger.on("click", function () {
          $filterTrigger.toggleClass("is-open");
          $filters.toggleClass("is-open");
        });
      });

      $(once("scripts", "html", context))
        .each(function () {
          /**
           *  Hamburger mobile menu toggle and mobile menu actions
           */
          //('html hamburger is running');
          var $hamburger = $(".hamburger");
          var $menuToggle = $("nav");
          var $headerToggle = $("header.header");
          var $offCanvas = $(".menu__off-canvas");
          $hamburger.on("click", function (e) {
            $hamburger.toggleClass("is-active");
            $menuToggle.toggleClass("is-active");
            $headerToggle.toggleClass("is-active");
            $offCanvas.toggleClass("is-active");

            if ($(".search-trigger").hasClass("is-active")) {
              $searchFormElements.removeClass("is-active");
              $searchTrigger.removeClass("is-active");
            }
          });
          /**
           *  Search actions - Toggle and all that jazz
           */
          var $searchTrigger = $(".search-trigger");
          var $searchFormElements = $(".search-wrapper");
          $searchTrigger.on("click", function (e) {
            $searchTrigger.toggleClass("is-active");
            $searchFormElements.toggleClass("is-active");
            $("#search-1").find(".search-input").focus();

            if ($(".hamburger").hasClass("is-active")) {
              $hamburger.toggleClass("is-active");
              $menuToggle.toggleClass("is-active");
              $headerToggle.toggleClass("is-active");
              $offCanvas.toggleClass("is-active");
            }
          });
          /**
           * Execute code when the window scrolls.
           */
          $(window).on("scroll", function () {
            if ($(document).scrollTop() > 180) {
              $("header").removeClass("large").addClass("small");
              $("main").removeClass("large").addClass("small");
              $(".hero").removeClass("large").addClass("small");
            } else {
              $("header").removeClass("small").addClass("large");
              $("main").removeClass("small").addClass("large");
              $(".hero").removeClass("small").addClass("large");
            }
          });

          // accessable menu
          $.fn.accessibleDropDown = function () {
            var el = $(this);
            $(".menu_main__link", el)
              .focus(function () {
                $(this).parents("li").addClass("dropdown-open");
                $(this).next("ul").addClass("menu-open");
              })
              .blur(function () {
                $(this).parents("li").removeClass("dropdown-open");
                $(this).next("ul").removeClass("menu-open");
              });
          };
          $(".menu__primary-main").accessibleDropDown();

          // Program tabs ****
          // Parse the URL and separate the variables
          function getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split();
            for (var i = 0; i < vars.length; i++) {
              var pair = vars[i].split("=");
              if (pair[0] == variable) {
                return pair[1];
              }
            }
            return false;
          }
          var currentTab;
          currentTab = getQueryVariable("tab");
          // If tab name is in the URL, go to that tab
          if (currentTab) {
            $("ul.sidebar-tabs li a").removeClass("is-active");

            // Adds active on tab list item
            $('ul.sidebar-tabs li a[data-id="' + currentTab + '"]').addClass(
              "is-active"
            );
            // Adds click to tab that is active on page load to filter content
            setTimeout(() => {
              $('ul.sidebar-tabs li a[data-id="' + currentTab + '"]').click();
            }, 5);
          }

          $(".sidebar-tabs li a").click(function () {
            // Active state for tabs
            $(".sidebar-tabs li a").removeClass("is-active");
            $(this).addClass("is-active");
            var tab = $(this).data("id");
            history.replaceState("", "", "?" + "tab=" + tab);

            // Active state for Tabs Content
            $(".sidebar_tab_content_container > .tab_content_active")
              .removeClass("tab_content_active")
              .fadeOut(200);
            $(this.rel).fadeIn(500).addClass("tab_content_active");
          });
        });

      $(once("scripts", ".sidebar-title-wrap .expand"))
        .each(function () {
          /**
           * sidebar mobile triggler
           */
          //console.log('sidebar title wrap is running');
          var $sidebarTitle = $(".sidebar-title-wrap .expand");
          var $sidebarMenu = $("#menuSidebar-navigation ul");
          $sidebarTitle.on("click", function (e) {
            $sidebarTitle.toggleClass("is-open");
            $sidebarMenu.toggleClass("is-open");
          });
        });

      $(once("scripts", ".views-grid-listing .views-row"))
        .each(function () {
          /**
            * Open Link if user clicks anywhere on the listing item
            */
          //console.log('views grid is running');
          $(this).on('click', function(e) {
            e.preventDefault();
            var listingURL = $(this).find('a').attr('href');
            window.open(listingURL);
          });
        });

      $(once("scripts", ".accordion .paragraph--type--accordion-element"))
        .each(function () {
          //console.log('accordion paragraph is running');
          $(this).addClass('closed').find('.js-accordion__panel').hide().attr('aria-expanded', 'false');
          $(this).find('.js-accordion__header').on('click', function() {
            $(this).parent().toggleClass('closed').find('.js-accordion__panel').slideToggle();

            if( $(this).parent().hasClass('closed')) {
              $(this).parent().attr('aria-expanded', 'false');
            } else {
              $(this).parent().attr('aria-expanded', 'true');
            }
          });        
        });

      $(once("scripts", ".toggle-show"))
        .each(function () {
          //console.log('toggle show is running');
          $(this).find(".show-all").on("click", function() {
            $(".accordion .paragraph--type--accordion-element").removeClass('closed').attr('aria-expanded', 'true');
            $(".accordion .paragraph--type--accordion-element").find('.js-accordion__panel').slideDown();
          });

          $(this).find(".hide-all").on("click", function() {
            $(".accordion .paragraph--type--accordion-element").addClass('closed').attr('aria-expanded', 'false');
            $(".accordion .paragraph--type--accordion-element").find('.js-accordion__panel').slideUp();
          });
        });

      $(once("scripts", "a[href$='.pdf']"))
        .each(function () {
          //console.log('pdf is running');
          $(this).attr('target', '_blank' );
        });

      $('a').filter(function() {
        return this.hostname && this.hostname !== location.hostname;
      }).attr('target', '_blank');
    },
  };
})(Drupal, jQuery, once);
